import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  error: null,
}

const slice = createSlice({
  name: 'privateRoute',
  initialState: initialState,
  reducers: {
    getUserDataAction: (state) => {
      state.loading = true
      state.error = null
    },
    getUserDataSuccessAction:(state)=>{
      state.loading = false
      state.error = null
    },
    getUserDataErrorAction: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
    privateRouteResetState: () => initialState,
  },
});

export const {
  getUserDataAction,
  getUserDataSuccessAction,
  getUserDataErrorAction,
  privateRouteResetState
} = slice.actions

export default slice.reducer
